import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import { Logo } from '../../Assets';
import { ProfileForm } from '../../components';

import './onboarding-info.scss';
import { parseDate } from '../../utils/helper';

const OnBoardingInfo = ({
  userInfo: {
    email,
    first_name,
    last_name,
    token,
    dob,
    company_anniversary,
    personal_email,
  },
  info,
}) => {
  const history = useHistory();

  useEffect(() => {
    if (!email && !Object.keys(info).length) {
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const data = {
    email: email || info.email,
    firstName: first_name || info.first_name || '',
    lastName: last_name || info.last_name || '',
    personalEmail: personal_email || info.personal_email || '',
    birthDate: '',
    companyAnniversary: '',
  };

  if (info.dob || dob) {
    const doOfBirth = dob || info.dob;
    data.birthDate = parseDate(doOfBirth);
  }

  if (info.company_anniversary || company_anniversary) {
    const anniversary = company_anniversary || info.company_anniversary;
    data.companyAnniversary = parseDate(anniversary);
  }

  if (token) {
    data.token = token;
  }

  return (
    <div className="info-wrapper">
      <div className="logo-wrapper">
        <Logo width={173} height={34} />
      </div>
      <div className="custom-info-wrapper">
        <h3>Before we get started,</h3>
        <h5>Tell us a little bit about yourself</h5>
        <p>
          Let’s get started by confirming the information below. Feel free to
          update it as you need. 
        </p>
        <ProfileForm
          details={data}
          isOnboarding={!info || token}
          boardingProcess
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.manager.userInfo || {},
  info: state.auth.userInfo.info || {},
});

export default connect(mapStateToProps)(OnBoardingInfo);
